import styled from 'styled-components';
import { Typography } from 'modules/v2';
export const AnimatedTypography = styled(Typography) `
  opacity: ${({ $visible }) => ($visible ? 1 : 0)};
  transform: translateY(${({ $visible }) => ($visible ? 0 : '-75%')});
  transition:
    opacity ${({ $transitionDuration }) => `${$transitionDuration}ms`} ease,
    transform ${({ $transitionDuration }) => `${$transitionDuration}ms`} ease;
`;
